export default "__VITE_ASSET__CLmp3PCc__"